import { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import MyFeedback from './pages/MyFeedback';
import ResponseViewer from './pages/ResponseViewer';
import FeedbackEditor from './pages/FeedbackEditor';
import FeedbackTaker from './pages/FeedbackTaker';
import InstanceManager from './pages/InstanceManager';
import InstanceAnalytics from './pages/InstanceAnalytics';
import Administration from './pages/Administration';
import Results from './pages/Results';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import { AuthProvider } from './context/AuthContext';
import { FeedbackProvider } from './context/FeedbackContext';
import { ThemeProvider } from './context/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import { MsalProvider } from './providers/MsalProvider';
import { AuthHandler } from './components/auth/AuthHandler';

export function App() {
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 1024);

  return (
    <MsalProvider>
      <AuthProvider>
        <AuthHandler>
          <FeedbackProvider>
            <ThemeProvider>
              <Toaster position="top-right" />
              <Router>
                <Routes>
                  <Route
                    path="/*"
                    element={
                      <div className="h-screen flex overflow-hidden bg-gray-100 dark:bg-gray-900">
                        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
                        <div className="flex flex-col flex-1 w-full overflow-auto">
                            <Header
                              toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
                              sidebarOpen={sidebarOpen}
                            />
                            <main className="flex-1 relative overflow-y-auto focus:outline-none w-full">
                              <div className="h-full w-full">
                                <Routes>
                                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                                  <Route path="/dashboard" element={<Dashboard view="dashboard" />} />
                                  <Route
                                    path="/feedback/list"
                                    element={
                                      <ProtectedRoute creatorOnly>
                                        <Dashboard view="feedback" />
                                      </ProtectedRoute>
                                    }
                                  />
                                  <Route path="/feedback/assigned" element={<MyFeedback />} />
                                  <Route
                                    path="/feedback/response/:feedbackId/:instanceId"
                                    element={
                                      <ProtectedRoute>
                                        <ResponseViewer />
                                      </ProtectedRoute>
                                    }
                                  />
                                  <Route
                                    path="/feedback/create"
                                    element={
                                      <ProtectedRoute creatorOnly>
                                        <FeedbackEditor />
                                      </ProtectedRoute>
                                    }
                                  />
                                  <Route
                                    path="/feedback/edit/:id"
                                    element={
                                      <ProtectedRoute creatorOnly>
                                        <FeedbackEditor />
                                      </ProtectedRoute>
                                    }
                                  />
                                  <Route
                                    path="/feedback/take/:id/:instanceId"
                                    element={
                                      <ProtectedRoute>
                                        <FeedbackTaker />
                                      </ProtectedRoute>
                                    }
                                  />
                                  <Route
                                    path="/instances"
                                    element={
                                      <ProtectedRoute creatorOnly>
                                        <InstanceManager />
                                      </ProtectedRoute>
                                    }
                                  />
                                  <Route
                                    path="/results"
                                    element={
                                      <ProtectedRoute creatorOnly>
                                        <Results />
                                      </ProtectedRoute>
                                    }
                                  />
                                  <Route
                                    path="/analytics/:instanceId"
                                    element={
                                      <ProtectedRoute creatorOnly>
                                        <InstanceAnalytics />
                                      </ProtectedRoute>
                                    }
                                  />
                                  <Route
                                    path="/administration"
                                    element={
                                      <ProtectedRoute adminOnly>
                                        <Administration />
                                      </ProtectedRoute>
                                    }
                                  />
                                </Routes>
                              </div>
                            </main>
                          </div>
                        </div>
                      }
                    />
                  </Routes>
              </Router>
            </ThemeProvider>
          </FeedbackProvider>
        </AuthHandler>
      </AuthProvider>
    </MsalProvider>
  );
}